import fileReel from "./../../../components/Data/dataReel";

const Reel = () => {
  return (
    <div className="container">
      <div className="main mt ml mr mb">
        <div className={`content_proyect container`}>
          <div className="row">
            {fileReel &&
              fileReel.map(
                (item, index) =>
                  item !== null && (
                    <div className="col-12 col-sm-6 col-md-4">
                      <div
                        key={index}
                        dangerouslySetInnerHTML={{
                          __html: `${item.name}`,
                        }}
                      ></div>
                    </div>
                  )
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Reel;
